var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "meta"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("Address")]), _c('p', {
    staticClass: "meta_value addr"
  }, [_c('span', [_vm._v(_vm._s(_vm.addressID))]), _c('CopyText', {
    staticClass: "copy_but",
    attrs: {
      "value": "".concat(_vm.addressID)
    }
  }), _vm.alias ? _c('span', {
    staticClass: "alias"
  }, [_vm._v(_vm._s(_vm.alias))]) : _vm._e()], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("AVAX Balance")]), _c('div', {
    staticClass: "meta_value symbol"
  }, [_c('div', {
    staticClass: "avax_balance_container"
  }, [_c('div', [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    }
  }, [_c('v-tab', [_vm._v("Summary")]), _c('v-tab', [_vm._v("Detail")]), _c('v-tab-item', {
    staticClass: "tab_content"
  }, [_c('AVAXBalanceTableSummary', {
    attrs: {
      "p-unlocked": _vm.P_unlocked,
      "p-locked-stakeable": _vm.P_lockedStakeable,
      "p-locked-not-stakeable": _vm.P_lockedNotStakeable,
      "p-staked": _vm.P_staked,
      "xp-unlocked": _vm.XP_unlocked,
      "x-unlocked": _vm.X_unlocked,
      "x-locked": _vm.X_locked,
      "xc-unlocked": _vm.XC_unlocked
    }
  })], 1), _c('v-tab-item', {
    staticClass: "tab_content"
  }, [_c('AVAXBalanceTableDetail', {
    attrs: {
      "p-unlocked": _vm.P_unlocked,
      "p-locked-stakeable": _vm.P_lockedStakeable,
      "p-locked-not-stakeable": _vm.P_lockedNotStakeable,
      "p-staked": _vm.P_staked,
      "xp-unlocked": _vm.XP_unlocked,
      "x-unlocked": _vm.X_unlocked,
      "x-locked": _vm.X_locked,
      "xc-unlocked": _vm.XC_unlocked
    }
  })], 1)], 1)], 1)])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v("X-Chain Portfolio")]), _c('div', {
    staticClass: "meta_value"
  }, [_c('BalanceTable', {
    attrs: {
      "assets": _vm.assets
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }